import { Button, Modal, ModalBody, ModalContent, ModalOverlay, Text, VStack, ModalFooter, ModalHeader, Icon, HStack } from '@chakra-ui/react';
import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { WarningIcon } from '@chakra-ui/icons';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function DeleteAssociado(props) {
  const { user } = useContext(AccountContext);
  const disclosure = props.disclosure;
  const associado = props.associado;
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const navigate = useNavigate();

  async function deleteAssociado() {
    setLoading(true);
    setError(null);
    try {
      const url = `${ENDPOINT}/client/delete_associado`;
      const response = await api(url, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({ associado_id: associado.paciente_id, titular_id: user.id_cliente_deovita }),
      });
      const postsData = await response.json();
      if (postsData.success) {
        setLoading(false);
        disclosure.onClose();
        navigate('/alerts/sucesso/excluir-associado');
      } else {
        setError(postsData.message || 'Ocorreu um erro ao excluir o associado. Por favor, tente novamente.');
        setLoading(false);
      }
    } catch (error) {
      setError('Ocorreu um erro ao excluir o associado. Por favor, tente novamente.');
      setLoading(false);
    }
  }
  return (
    <Modal isOpen={disclosure.isOpen} onClose={disclosure.onClose} isCentered>
      <ModalOverlay  />

      <ModalContent maxW="320px" borderRadius="16px" px={2} py={3}>
        <ModalHeader textAlign="center">
          <VStack spacing={2}>
            <Icon as={WarningIcon} boxSize={8} color="red.500" />
            <Text fontSize="lg" fontWeight="bold">
              Excluir associado
            </Text>
          </VStack>
        </ModalHeader>

        <ModalBody>
          <VStack spacing={3} textAlign="center">
            <Text color="gray.700" fontSize="md">
              Tem certeza que deseja excluir este associado?
            </Text>

            <Text color="gray.500" fontSize="sm">
              Esta ação não pode ser desfeita.
            </Text>

            {error && (
              <Text color="red.500" fontSize="sm">
                {error}
              </Text>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <HStack w="100%" spacing={3}>
            <Button flex={1} variant="outline" onClick={disclosure.onClose} isDisabled={loading}>
              Cancelar
            </Button>

            <Button flex={1} colorScheme="red" onClick={deleteAssociado} isLoading={loading} _focus={{ boxShadow: 'none' }}>
              Excluir
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default DeleteAssociado;
